const FilledStar = ({ fill = '#4A4A4A' }: { fill?: string }) => {
    return (
        <svg
            width="41"
            height="41"
            viewBox="0 0 41 41"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.5816 7.54732C21.5753 5.43865 18.5738 5.43865 17.5676 7.54732L14.4797 14.0185L7.37109 14.9555C5.05469 15.2609 4.12715 18.1155 5.82168 19.7241L11.0219 24.6605L9.7164 31.7108C9.29099 34.0082 11.7193 35.7724 13.7728 34.6579L20.0746 31.2377L26.3763 34.6579C28.4298 35.7724 30.8581 34.0082 30.4327 31.7108L29.1272 24.6605L34.3275 19.7241C36.022 18.1155 35.0945 15.2609 32.7781 14.9555L25.6694 14.0185L22.5816 7.54732Z"
                fill={fill}
            />
        </svg>
    )
}

export default FilledStar
